export default "__VITE_ASSET__U2WG9rXA__"